const ExceptionConstants = {
  GET_SELECTED_EXCEPTION_LOG_SUCCESS: "GET_SELECTED_EXCEPTION_LOG_SUCCESS",
  GET_SELECTED_EXCEPTION_LOG_FAILURE: "GET_SELECTED_EXCEPTION_LOG_FAILURE",
  GET_ALL_EXCEPTION_LOG_SUCCESS: "GET_ALL_EXCEPTION_LOG_SUCCESS",
  GET_ALL_EXCEPTION_LOG_FAILURE: "GET_ALL_EXCEPTION_LOG_FAILURE",
  DELETE_EXCEPTION_SUCCESS: "DELETE_EXCEPTION_SUCCESS",
  DELETE_EXCEPTION_FAILURE: "DELETE_EXCEPTION_FAILURE",
  DELETE_MUL_EXCEPTION_SUCCESS: "DELETE_MUL_EXCEPTION_SUCCESS",
  DELETE_MUL_EXCEPTION_FAILURE: "DELETE_MUL_EXCEPTION_FAILURE",
};
export default ExceptionConstants;
